import getBannersForEntities from './get-banners-for-entities';
import getBannersForNodes from './get-banners-for-nodes';
export default function injectMultipleBanners(entities, banner) {
  const {
    transform
  } = banner;
  const entitiesSet = [...entities];
  const injectedEntities = transform ? getBannersForNodes(entitiesSet, banner) : getBannersForEntities(entitiesSet, banner);
  return injectedEntities;
}
//# sourceMappingURL=inject-multiple-banners.js.map